<knk-default-dialog
  [header]="'dynamicEditor.defaults' | translate"
  [cancelLabel]="'common.cancel' | translate"
  [doneLabel]="'common.save' | translate"
  [doneEnabled]="!loading()"
  [doneLoading]="saving()"
  (done)="save()"
  (cancel)="cancel()"
>
  <tui-loader [showLoader]="loading()">
    <div class="overflow-hidden rounded-lg border border-gray-300 shadow-sm">
      <ngx-monaco-editor class="!h-[420px]" [options]="monacoOptions" [(ngModel)]="value"></ngx-monaco-editor>
    </div>
  </tui-loader>
</knk-default-dialog>
